import { runCodeRuleAudit, type CodeRuleAuditRequest, type CodeRuleAuditResult } from "@/api/codeRuleAudits";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

export function useCodeRuleAudit() {
  const controllerRef = useRef<AbortController | null>(null);

  const mutation = useMutation<CodeRuleAuditResult, Error, CodeRuleAuditRequest>({
    mutationFn: (body) => {
      controllerRef.current?.abort();
      const controller = new AbortController();
      controllerRef.current = controller;
      return runCodeRuleAudit(body, controller.signal);
    },
  });

  const cancel = () => {
    controllerRef.current?.abort();
    mutation.reset();
  };

  useEffect(() => () => controllerRef.current?.abort(), []);

  return {
    runAudit: mutation.mutate,
    cancel,
    data: mutation.data,
    isPending: mutation.isPending,
    isError: mutation.isError,
  };
}
